module.exports = __webpack_public_path__ + "media/images/pensamentos-837d2ef4e8e64dafe9e57cceab42bc85.svg";